import { Link } from 'react-router-dom';
import { AppGrid } from '../components/AppGrid';

export function HomePage() {
  return (
    <>
      <section className="hero-section">
        <div className="hero-copy">
          <p className="eyebrow">2xHappiness Studio</p>
          <h1>Two pieces of happiness, shared with the world.</h1>
          <p className="hero-text">
            We build small, thoughtful apps that make everyday moments easier, lighter, and a little sweeter.
            One piece for you, one piece to share.
          </p>
          <div className="hero-actions">
            <a className="primary-action" href="#apps">View our apps</a>
            <Link className="secondary-action" to="/apps/device-cleaner">Device Cleaner</Link>
          </div>
        </div>
        <div className="hero-visual" aria-label="2xHappiness brand preview">
          <div className="sugar-card">
            <span>2x</span>
            <strong>One for you.</strong>
            <strong>One for someone else.</strong>
            <p>Simple software with a warm little purpose.</p>
          </div>
        </div>
      </section>

      {/*<section className="feature-band" aria-label="Company values">*/}
      {/*  {company.values.map((value) => (*/}
      {/*    <div className="feature-pill" key={value}>{value}</div>*/}
      {/*  ))}*/}
      {/*</section>*/}

      <section className="section-block" id="apps">
        <div className="section-heading">
          <p className="eyebrow">Our apps</p>
          {/*<h2>Start with the tools already in people&apos;s hands.</h2>*/}
          {/*<p>Each app has its own product page and its own legal pages, so the website can grow without mixing policies across products.</p>*/}
        </div>
        <AppGrid />
      </section>

      {/*<section className="section-block roadmap-section">*/}
      {/*  <div className="section-heading compact">*/}
      {/*    <p className="eyebrow">Website structure</p>*/}
      {/*    <h2>Built for more apps later.</h2>*/}
      {/*  </div>*/}
      {/*  <div className="roadmap-grid">*/}
      {/*    <div>*/}
      {/*      <strong>Company home</strong>*/}
      {/*      <p>The homepage explains the 2xHappiness purpose first, then routes users toward available apps.</p>*/}
      {/*    </div>*/}
      {/*    <div>*/}
      {/*      <strong>App paths</strong>*/}
      {/*      <p>Each app can live under its own path, such as /apps/device-cleaner.</p>*/}
      {/*    </div>*/}
      {/*    <div>*/}
      {/*      <strong>Separate policies</strong>*/}
      {/*      <p>Privacy and Terms are scoped per app, so Story Post can get its own pages when it is ready.</p>*/}
      {/*    </div>*/}
      {/*  </div>*/}
      {/*</section>*/}
    </>
  );
}
